import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  router: {
    prefetchLinks: false
  },
  theme: {
    themes: {
      light: {
        primary: '#003e94',
        secondary: '#fed12f',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
  icons: {
    iconfont: "mdi",
    values: {
      radioOn: 'icon-Checked-Disabled'
    }
  }
});
